import React from 'react';

const STATUS_BADGE = {
    Scheduled: 'bg-green-100 text-green-700',
    Rescheduled: 'bg-amber-100 text-amber-700',
    Completed: 'bg-blue-100 text-blue-700',
    Cancelled: 'bg-red-100 text-red-700',
};

const STATUS_BORDER = {
    Scheduled: 'border-l-green-400',
    Rescheduled: 'border-l-amber-400',
    Completed: 'border-l-blue-400',
    Cancelled: 'border-l-red-300',
};

const ClinicIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5 text-indigo-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        />
    </svg>
);

const BookingCard = ({ booking, onCancel, onReschedule, onViewDetails, onRebook }) => {
    const { clinicName, city, status, memberName, date, time } = booking;
    const isUpcoming = status === 'Scheduled' || status === 'Rescheduled';
    const isPast = status === 'Completed';

    return (
        <div className={`bg-white rounded-2xl border border-gray-100 shadow-md p-4 mb-3 border-l-4 ${STATUS_BORDER[status] || 'border-l-gray-300'}`}>
            {/* Clinic info + status badge */}
            <div className="flex justify-between items-start mb-3">
                <div className="flex items-center gap-2.5">
                    <div className="w-9 h-9 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <ClinicIcon />
                    </div>
                    <div>
                        <p className="font-bold text-gray-800 text-sm leading-tight">{clinicName}</p>
                        <p className="text-xs text-gray-400 mt-0.5">{city}</p>
                    </div>
                </div>
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0 ${STATUS_BADGE[status] || 'bg-gray-100 text-gray-600'}`}>
                    {status}
                </span>
            </div>

            {/* Member / Date / Time */}
            <div className="grid grid-cols-3 gap-2 mb-3">
                <div>
                    <p className="text-xs text-gray-400">Member</p>
                    <p className="text-sm font-semibold text-gray-700">{memberName}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400">Date</p>
                    <p className="text-sm font-semibold text-gray-700">{date}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400">Time</p>
                    <p className="text-sm font-semibold text-gray-700">{time}</p>
                </div>
            </div>

            {/* Upcoming actions */}
            {isUpcoming && (
                <div className="flex items-center gap-2 border-t border-gray-100 pt-3">
                    <button
                        onClick={() => onCancel && onCancel(booking)}
                        className="flex-1 py-2 text-sm font-semibold text-red-500 bg-white border border-red-200 hover:bg-red-50 rounded-xl transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onReschedule && onReschedule(booking)}
                        className="flex-1 py-2 text-sm font-semibold text-indigo-600 bg-white border border-indigo-300 hover:bg-indigo-50 rounded-xl transition-colors"
                    >
                        Reschedule
                    </button>
                </div>
            )}

            {/* Past actions */}
            {isPast && (
                <div className="flex items-center gap-2 border-t border-gray-100 pt-3">
                    <button
                        onClick={() => onViewDetails && onViewDetails(booking)}
                        className="flex-1 py-2 text-sm font-semibold text-gray-600 bg-white border border-gray-200 hover:bg-gray-50 rounded-xl transition-colors"
                    >
                        View details
                    </button>
                    <button
                        onClick={() => onRebook && onRebook(booking)}
                        className="flex-1 py-2 text-sm font-semibold text-indigo-600 bg-white border border-indigo-300 hover:bg-indigo-50 rounded-xl transition-colors"
                    >
                        Rebook
                    </button>
                </div>
            )}
        </div>
    );
};

export default BookingCard;
